document.addEventListener('DOMContentLoaded', () => {
  const filterButtons = document.querySelectorAll('.recipe-filter-button');
  const productContainers = document.querySelectorAll('.product-container-wrapper');
  const recipeTabs = document.querySelector('.recipe-tabs');


  const firstButton = filterButtons[0];
  if (firstButton) {
    const firstFilterText = firstButton.textContent.trim().toLowerCase();
    productContainers.forEach((container) => {
      let title = container.querySelector('.product-title').innerHTML;
      title = title.trim().toLowerCase();

      if (title === firstFilterText) {
        container.style.display = 'flex';
      } else {
        container.style.display = 'none';
      }
    });
  }

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const scrollLeft = button.offsetLeft - 16;
      recipeTabs.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
      });
      const filterText = button.textContent.trim().toLowerCase();

      filterButtons.forEach((btn) => {
        btn.classList.remove('active', 'font-semibold');
        btn.classList.add('font-normal');
      });


      button.classList.add('active', 'font-semibold');
      button.classList.remove('font-normal');


      productContainers.forEach((container) => {
        let title = container.querySelector('.product-title').innerHTML;
        title = title.trim().toLowerCase();

        if (title === filterText) {
          container.style.display = 'flex';
        } else {
          container.style.display = 'none';
        }
      });
    });
  });
});